<template lang="pug">
  div
    | {{ $t('components.full_view_mode_switch.tpl.caption') }}
    a-switch.ml-2(
      :checked="projectGroupsFullViewMode"
      :defaultChecked="projectGroupsFullViewMode"
      @change="toggleProjectGroupsFullViewMode"
    )
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
  computed: {
    ...mapState([
      'projectGroupsFullViewMode',
    ]),
  },
  methods: {
    ...mapMutations([
      'toggleProjectGroupsFullViewMode',
    ]),
  },
};
</script>
